module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6GzRp"))).then(() => parcelRequire('32bed'));